export const INIT_UNSUBSCRIBE_FROM_ISSUE_PIPELINE = 'INIT_UNSUBSCRIBE_FROM_ISSUE_PIPELINE';
export const INIT_UNSUBSCRIBE_FROM_ISSUE_PIPELINE_SUCCESS = 'INIT_UNSUBSCRIBE_FROM_ISSUE_PIPELINE_SUCCESS';
export const INIT_UNSUBSCRIBE_FROM_ISSUE_PIPELINE_ERROR = 'INIT_UNSUBSCRIBE_FROM_ISSUE_PIPELINE_ERROR';
